import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class Airtable extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M10.5332267,0.249 L1.73869333,3.88806667 C1.24962667,4.09046667 1.25469333,4.78513333 1.74682667,4.9802 L10.57816,8.48233333 C11.35416,8.79006667 12.2182933,8.79006667 12.99416,8.48233333 L21.8256267,4.9802 C22.3176267,4.78513333 22.3228267,4.09046667 21.8336267,3.88806667 L13.0392267,0.249 C12.2368267,-0.083 11.3354933,-0.083 10.5332267,0.249" />
        <path d="M12.56968,10.3947733 L12.56968,19.1435733 C12.56968,19.5597067 12.98928,19.84464 13.37608,19.6913067 L23.21688,15.8715733 C23.4415467,15.7825067 23.58888,15.56544 23.58888,15.32384 L23.58888,6.57504 C23.58888,6.15890667 23.16928,5.87397333 22.78248,6.02730667 L12.94168,9.84704 C12.7171467,9.93610667 12.56968,10.1531733 12.56968,10.3947733" />
        <path d="M10.2717867,10.8461867 L7.35125333,12.25632 L7.05472,12.3996533 L0.889653333,15.3536533 C0.498853333,15.5421867 5.33333333e-05,15.2573867 5.33333333e-05,14.8232533 L5.33333333e-05,6.61178667 C5.33333333e-05,6.45472 0.0805866667,6.31912 0.188586667,6.21698667 C0.233653333,6.17178667 0.28472,6.13458667 0.337786667,6.10512 C0.48512,6.01672 0.695253333,5.99312 0.87392,6.06378667 L10.22272,9.76792 C10.69792,9.95645333 10.7352533,10.62232 10.2717867,10.8461867" />
        <path d="M10.2717867,10.8461867 L7.35125333,12.25632 L0.188586667,6.21698667 C0.233653333,6.17178667 0.28472,6.13458667 0.337786667,6.10512 C0.48512,6.01672 0.695253333,5.99312 0.87392,6.06378667 L10.22272,9.76792 C10.69792,9.95645333 10.7352533,10.62232 10.2717867,10.8461867" />
      </svg>
    );
  }
}

export default Airtable;
